module.exports = __webpack_public_path__ + "static/img/22038B_2_C_20240318_fit.2ee5330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22038B_2_C_20240318_fit.png
// module id = d/Ko
// module chunks = 0